export default function isAtTick(ctx): boolean {
	if (ctx.dataIndex === 0) {
		// Not perfect but works for now. Ideally we would do this somewhere once when the ticks change.
		ctx.chart.$datalabels.xTicks = {};
		for (const tick of ctx.chart.scales.x.ticks) {
			ctx.chart.$datalabels.xTicks[tick.value] = true;
		}
	}

	return ctx.dataIndex in (ctx.chart.$datalabels.xTicks || {});
}
